import Helix from '@charter/helix/build/video/index.min';

const state = {
    defaultData: null,
    config: {
        appVersion: null,
        startSession: null,
    },
};

import packageJson from '../../../package.json';

export const HELIX_APP_CONFIG = {
    domain: `video`,
    appName: `SpectrumReach`,
    appType: `Web`,
    startSession: `SpectrumReach_startSession_generic`,
    requirementsVersion: `2.389`,
    appVersion: packageJson.version,
    drmEnabled: true,
};

const isBrowser = typeof window !== `undefined`;

export default class HelixAnalyticsService {
    debugAppEvents: any;
    constructor(config, version) {
        try {
            if (config && version) {
                state.config = config;
                if (state.config) {
                    state.config.appVersion = version;
                }
            } else {
                console.error(
                    `Analytics Service | Error - No Config or Version provided.`
                );
                return;
            }
        } catch (e) {
            console.error(`Analytics Service | Error on Constructor : ${e}`);
            return;
        }

        this.init = this.init.bind(this);
        this.track = this.track.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        this.init();
    }

    init() {
        let endpoint;
        let env;
        if (!isBrowser) {
            return null;
        }

        try {
            Helix.useDefaultStorage();
            if (
                window.location.host === `spectrumreach.spectrumtoolbox.com` ||
                window.location.host.includes(`spectrumreach.com`)
            ) {
                env = `prod`;
                endpoint = `https://collector.pi.spectrum.net/api/collector?bulk=true`;
            } else if (window.location.host.includes(`localhost`)) {
                env = `local`;
                endpoint = `https://collector-dev.pi-charter.net/api/collector`;
            } else {
                env = `staging`;
                endpoint = `https://collector.pi-charter.net/api/collector?bulk=true`;
            }

            Helix.set(`endpoint`, endpoint);

            Helix.init(state.config)
                .then(() => {
                    if (Helix.get(`currentState`) === `blank`) {
                        Helix.trackStartSession(state.config.startSession);
                    }
                })
                .catch((e) => console.error(e, `INIT ERROR`));
        } catch (err) {
            console.error(err);
        }
    }

    /**
     * @doc method
     * @name analytics#track
     * @methodOf analytics
     * @returns {}
     * @description Calls Helix Track
     */
    track(id, adHocData?, options?) {
        if (!isBrowser) {
            return null;
        }
        try {
            Helix.track(id, adHocData, options);
        } catch (err) {
            if (this.debugAppEvents) {
                console.error(err);
            }
        }
    }

    /**
     * @doc method
     * @name analytics#trackPageView
     * @methodOf analytics
     * @returns {}
     * @description Calls Helix Track with a Complete PageView Cycle (Init-Completed). To be used when no Page load time calculation is required.
     */
    trackPageView = (pageName, adHocData?, pageUrl?) => {
        if (!isBrowser) {
            return null;
        }
        try {
            for (const msgEventType of [`pageViewInit`, `pageViewCompleted`]) {
                Helix.track(
                    `pageView`,
                    {
                        msgEventType,
                        appVersion: HELIX_APP_CONFIG.appVersion,
                        currPageAppSection: pageName,
                        currPageUrl: pageUrl || window.location.href,
                        currPageName: pageName,
                        currPageIsLazyLoad: true,
                        msgTriggeredBy: `user`,
                        ...adHocData,
                    },
                    pageUrl || ``
                );
            }
        } catch (err) {
            if (this.debugAppEvents) {
                console.error(err);
            }
        }
    };

    set(id, value) {
        try {
            Helix.set(id, value);
        } catch (err) {
            if (this.debugAppEvents) {
                console.error(err);
            }
        }
    }
    get(value) {
        try {
            return Helix.get(value);
        } catch (err) {
            if (this.debugAppEvents) {
                console.error(err);
            }
        }
    }
    getQubeHeaders(value) {
        try {
            return Helix.getQubeHeaders(value);
        } catch (err) {
            if (this.debugAppEvents) {
                console.error(err);
            }
        }
    }
}

export const helixAnalytics = new HelixAnalyticsService(
    HELIX_APP_CONFIG,
    HELIX_APP_CONFIG.appVersion
);
